import React from "react";
import { connect } from "react-redux";
import {getCollectionLayout} from "./section";

class CollectionPageBase extends React.Component {
  render() {
    return getCollectionLayout(this.props);
  }
}

function mapStateToProps(state) {
  return {
    config: state.qt.config
  }
}

export const CollectionPage = connect(mapStateToProps)(CollectionPageBase);
